var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfdoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 0H2.4C1.08 0 0 1.08 0 2.4V21.6C0 22.9255 1.07452 24 2.4 24H16.8C18.1255 24 19.2 22.9255 19.2 21.6V6C19.1955 5.68348 19.0661 5.38156 18.84 5.16L14.04 0.36C13.8184 0.133903 13.5165 0.00450846 13.2 0ZM13.2 6V2.892L16.308 6H13.2ZM16.8 8.4H13.2C11.8745 8.4 10.8 7.32548 10.8 6V2.4H2.4V21.6H16.8V8.4ZM13.2 18C13.8627 18 14.4 17.4627 14.4 16.8C14.4 16.1373 13.8627 15.6 13.2 15.6H6C5.33726 15.6 4.8 16.1373 4.8 16.8C4.8 17.4627 5.33726 18 6 18H13.2ZM14.4 12C14.4 12.6627 13.8627 13.2 13.2 13.2H6C5.33726 13.2 4.8 12.6627 4.8 12C4.8 11.3373 5.33726 10.8 6 10.8H13.2C13.8627 10.8 14.4 11.3373 14.4 12ZM7.2 8.4C7.86274 8.4 8.4 7.86274 8.4 7.2C8.4 6.53726 7.86274 6 7.2 6H6C5.33726 6 4.8 6.53726 4.8 7.2C4.8 7.86274 5.33726 8.4 6 8.4H7.2Z",
    fill: "#8B8A90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfdoc);
export default __webpack_public_path__ + "static/media/confdoc.4bef1695.svg";
export { ForwardRef as ReactComponent };